export const SIGNATURE_PAGE_MODE_EVENT = 'signature-page-mode-change';

const ALL_PAGES_STORAGE_KEY = 'signatureAppearanceAllPages';
const PREVIOUS_PAGE_STORAGE_KEY = 'signatureAppearancePreviousPage';

const normalizePage = (page, fallback = 1) => {
    const value = Number(page);
    return Number.isInteger(value) && value > 0 ? value : fallback;
};

export const isAllPagesModeEnabled = () =>
    sessionStorage.getItem(ALL_PAGES_STORAGE_KEY) === 'true';

export const getPreviousSignaturePage = (fallback = 1) =>
    normalizePage(sessionStorage.getItem(PREVIOUS_PAGE_STORAGE_KEY), normalizePage(fallback));

export const updateAllPagesMode = (enabled, currentPage) => {
    const allPages = Boolean(enabled);

    if (allPages && !isAllPagesModeEnabled()) {
        sessionStorage.setItem(PREVIOUS_PAGE_STORAGE_KEY, String(normalizePage(currentPage)));
    }

    sessionStorage.setItem(ALL_PAGES_STORAGE_KEY, String(allPages));
    const previousPage = getPreviousSignaturePage(currentPage);

    window.dispatchEvent(new CustomEvent(SIGNATURE_PAGE_MODE_EVENT, {
        detail: { allPages, previousPage }
    }));

    return previousPage;
};
